import image from "../../img/2022.png";
import React from "react";
import { All, Button, LP, PP } from "./Style";
function Twotwotwo() {
  return (
    <All>
      <LP zrodlo={image}></LP>
      <PP>
        <h1>2022</h1>
        <p>Rok 2022 był super :DDDDD</p>
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://www.youtube.com/watch?v=ykz8DG9Su3k"
        >
          <Button>Obejrzyj</Button>
        </a>
      </PP>
    </All>
  );
}

export default Twotwotwo;
